import { Chip } from '@/shared/ui/chip'

interface DepartmentBadgeProps {
  departments: string[]
  className?: string
}

// Отдел сотрудника из проекции хаба. Отделов может быть несколько (M2M хаба):
// показываем первый, остальные — счётчиком, чтобы строка участника не расползалась;
// полный список — в title. Пустой набор ничего не рисует (отделы не назначены —
// назначение живёт в хаб-UI).
export function DepartmentBadge({ departments, className }: DepartmentBadgeProps) {
  if (departments.length === 0) return null
  const [first, ...rest] = departments
  return (
    <Chip variant="soft" tone="neutral" title={departments.join(', ')} className={className}>
      {first}
      {rest.length > 0 && ` +${rest.length}`}
    </Chip>
  )
}
